import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './styles/base.css';
import { getCurrentLocale } from './services/api';
import { getConsentPreferences, updateGoogleConsent } from './utils/consent';
import { initGtagDebugging } from './utils/gtag-debug';

function Root() {
  useEffect(() => {
    const locale = getCurrentLocale();
    document.documentElement.lang = locale;
    document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr';
    try {
      localStorage.setItem('hm_locale', locale);
    } catch {}

    // Initialize consent preferences if they exist
    const consentPreferences = getConsentPreferences();
    if (consentPreferences) {
      updateGoogleConsent(consentPreferences);
    }

    // Initialize gtag debugging in development
    initGtagDebugging();
  }, []);
  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(<Root />);
